// Configuration utility - supports both runtime injection and build-time env vars
// Runtime config is injected by nginx at container start from environment variables

// Production fallback - Railway backend URL
const PRODUCTION_BACKEND_URL = 'https://wefaqna-production.up.railway.app';

const getConfig = (key) => {
  // First check runtime config (for production Docker deployments)
  if (typeof window !== 'undefined' &&
      window.RUNTIME_CONFIG &&
      window.RUNTIME_CONFIG[key] &&
      !window.RUNTIME_CONFIG[key].startsWith('__')) {
    return window.RUNTIME_CONFIG[key];
  }

  // Fallback to build-time environment variables
  const envValue = process.env[key];
  if (envValue) {
    return envValue;
  }

  return null;
};

// Export common config values
// Uses production URL as fallback if no config is available
export const BACKEND_URL = getConfig('REACT_APP_BACKEND_URL') || PRODUCTION_BACKEND_URL;
export const API_URL = getConfig('REACT_APP_API_URL') || BACKEND_URL;

export default { BACKEND_URL, API_URL };
